<template>
  <v-row>
    <v-col cols="12" v-if="baseLoader">
      <v-boilerplate type="table-heading, list-item-two-line"/>
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table"/>
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{name: 'SubscriptionList'}" class="subtitle-1 routerLink font-weight-medium">Suscripciones</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 200px;' : 'max-width: 300px;'" v-if="instance.customer">{{instance.customer.name}}</span>
             </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items v-if="['active', 'needs_attention'].includes(instance.status)">
            <v-row align="center" justify="center" class="mr-1">

              <!-- action initialize process -->
              <v-btn v-if="instance.status === 'active' && !isFuture && !isMetered" @click="dialogProcessSubscription=true" outlined><v-icon color="yellow darken-3" left size="20">mdi-lightning-bolt</v-icon>Procesar ahora</v-btn>
              <!-- end action initialize process -->

              <v-btn class="ml-2" :to="{name: 'SubscriptionUpdate', params: {id: instance.id}}" outlined retain-focus-on-click color="secondary">Editar</v-btn>
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{on, attrs}">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" outlined color="secondary" :ripple="false" retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" @click="dialogDestroy=true" :ripple="false">
                    <v-list-item-title class="subtitle-2 red--text font-weight-medium">Cancelar suscripción</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />

        <!-- if subscription needs attention -->
        <template v-if="instance.status === 'needs_attention'">
          <v-card-text class="py-4">
            <v-alert class="my-0 body-2" dark dense prominent color="deep-orange" border="left" type="info" icon="mdi-clock-outline">
              <v-row align="center">
                <v-col class="grow">
                  {{$t(`api.${instance.needs_attention_reason}`)}}<template v-if="instance.status_description">. {{instance.status_description}}</template>
                </v-col>
                <v-col class="shrink">
                  <v-btn class="ml-2" @click="solve" color="deep-orange darken-4" retain-focus-on-click><v-icon left>mdi-auto-fix</v-icon>Marcar como resuelto</v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-card-text>
          <v-divider />
        </template>
        <!-- end if subscription needs attention -->

        <v-card-text class="pa-0">
          <v-row class="mx-0 background">
            <v-col md="2">
              <span class="d-block mb-1">Estado</span>
              <v-chip v-if="instance.status === 'active'" color="lightBlue" text-color="primary" small>Activo <v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
              <v-chip v-else-if="instance.status === 'paused'" color="defaultGrey" text-color="secondary" small>Pausado<v-icon class="ml-1" x-small>mdi-pause</v-icon></v-chip>
              <v-chip v-else-if="instance.status === 'cancelled'" color="defaultGrey" text-color="secondary" small>Cancelado<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
              <v-chip v-else-if="instance.status === 'finalized'" color="defaultGrey" text-color="secondary" small>Finalizado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
              <v-chip v-else-if="instance.status === 'needs_attention'" color="defaultGrey" text-color="secondary" small>Necesita atención<v-icon class="ml-1" x-small>mdi-clock-outline</v-icon></v-chip>
            </v-col>
            <v-divider class="my-2" vertical />
            <v-col md="2">
              <span class="d-block mb-1">Desde</span>
              <span class="body-1 font-weight-medium mr-1">{{instance.date_start | date}}</span>
            </v-col>
            <template v-if="['active', 'needs_attention'].includes(instance.status)">
              <v-divider class="my-2" vertical />
              <v-col md="2">
                <span class="d-block mb-1">Hasta</span>
                <span class="body-1 font-weight-medium mr-1" v-if="instance.end_date">{{instance.end_date | date}}</span>
                <span class="text--disabled font-italic" v-else>Sin término definido</span>
              </v-col>
              <v-divider class="my-2" vertical />
              <v-col md="4">
                <span class="d-block mb-1">Próxima facturación</span>
                <span class="body-1 font-weight-medium mr-1">
                  <template v-if="instance.next_billing <= today">
                    <template v-if="instance.status === 'active'">Hoy en las próximas horas</template>
                    <template v-else-if="instance.status === 'needs_attention'">
                      Reintento en las próximas horas
                    </template>
                  </template>
                  <template v-else>{{instance.next_billing | date}}</template>
                </span>
              </v-col>
            </template>
            <template v-else-if="instance.status === 'cancelled'">
              <v-divider class="my-2" vertical />
              <v-col md="4">
                <span class="d-block mb-1">Cancelación</span>
                <span class="body-1 font-weight-medium mr-1">{{instance.cancelled | date}}</span>
                <span v-if="instance.cancel_reason === 'not_paid'">Sin pago</span>
                <span v-if="instance.cancel_reason === 'no_card'">Sin tarjeta de crédito o débito</span>
                <span v-if="instance.cancel_reason === 'fraud_review_failed'">Revisión de fraude fallida</span>
                <span v-if="instance.cancel_reason === 'non_compliant_customer'">Cliente no conforme</span>
                <span v-if="instance.cancel_reason === 'not_specified'">No especificado</span>
              </v-col>
            </template>
            <template v-else-if="instance.status === 'finalized'">
              <v-divider class="my-2" vertical />
              <v-col md="4">
                <span class="d-block mb-1">Última facturación</span>
                <span class="body-1 font-weight-medium mr-1">{{instance.next_billing | date}}</span>
              </v-col>
            </template>
          </v-row>
          <v-divider />
          <v-row>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Información general</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Cliente</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn :to="{name: 'CustomerRetrieveUpdate', params: {id: instance.customer.id}}" v-if="instance.customer" text color="primary" :ripple="false">{{instance.customer.name}}<v-icon right small>mdi-arrow-right</v-icon></v-btn>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item v-if="instance.orgunit">
                  <v-list-item-title>Unidad organizativa</v-list-item-title>
                  <v-list-item-subtitle>{{orgunitsDetail.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Workflow</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn v-on="on" text color="primary" :ripple="false">
                          <template v-if="instance.collection_scheme == 'charge_payment'">Primero procesar el pago</template>
                          <template v-else>Primero crear la factura</template>
                          <v-icon right small>mdi-open-in-new</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver workflow</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn class="font-weight-regular" @click="toClipboard(instance.id)" text color="secondary" v-on="on" :ripple="false">{{instance.id}}</v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Actualizado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.updated | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Información de facturación</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Tipo de cambio</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="instance.custom_change">1 {{currency}} = {{instance.custom_change}} {{instance.customer.currency}}</template>
                    <template v-else-if="currency === instance.customer.currency">No aplicable</template>
                    <template v-else>Automático</template>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Plazo de pago</v-list-item-title>
                  <v-list-item-subtitle>{{instance.expiration_days}} días</v-list-item-subtitle>
                </v-list-item>
                <template v-if="instance.coupon">
                  <v-list-item>
                    <v-list-item-title>Descuento</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-btn :to="{name: 'CouponRetrieveUpdate', params: {id: instance.coupon.id}}" text color="primary">{{instance.coupon.name}}</v-btn>
                      por
                      <span v-if="instance.coupon.discount_scheme === '%'">{{instance.coupon.amount | number(false)}} %</span>
                      <span v-if="instance.coupon.discount_scheme === '$'">{{instance.coupon.amount | currency(instance.coupon.currency.id)}} {{instance.coupon.currency.id}}</span>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Validez del descuento</v-list-item-title>
                    <v-list-item-subtitle>
                      <span v-if="instance.coupon.duration_scheme === 'one_time'">por {{instance.coupon_redemptions ? 0 : 1}} ciclos de facturación restantes</span>
                      <span v-if="instance.coupon.duration_scheme === 'forever'">para siempre</span>
                      <span v-if="instance.coupon.duration_scheme === 'limited'">por {{instance.coupon.duration_times - instance.coupon_redemptions}} ciclos de facturación restantes</span>
                    </v-list-item-subtitle>
                  </v-list-item>
                </template>
                <v-list-item>
                  <v-list-item-title>Tipo de factura</v-list-item-title>
                  <v-list-item-subtitle>{{instance.document | invoiceTypeName(true)}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Facturas</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn :to="{name: 'InvoiceList', query: {subscription: instance.id}}" text color="primary" :ripple="false">Ver facturas generadas<v-icon right small>mdi-arrow-right</v-icon></v-btn>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Próxima factura</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-btn @click="renderDocument('subscriptions')" color="primary" :ripple="false" text>Previsualizar<v-icon right small>mdi-open-in-new</v-icon></v-btn>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- source list -->
      <v-card class="px-0 my-5">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Tarjeta del cliente</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn :to="{ name: 'CustomerRetrieveUpdate', params: { id: instance.customer.id }, query: { ref: 'sources'} }" target="_blank" outlined>Administrar tarjetas del cliente<v-icon right small>mdi-open-in-new</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-list class="transparent" v-if="sourcesList.length">
            <v-list-item v-for="(d, i) in sourcesList" :key="i">
              <v-list-item-icon>
                <img :src="require(`@/assets/appAsset-brand--${d.card.brand}.svg`)" :alt="d.card.brand" height="24">
              </v-list-item-icon>
              <v-list-item-title>
                <span class="body-2 text--secondary font-weight-medium">•••• •••• •••• {{d.card.last4}}</span>
              </v-list-item-title>
              <v-list-item-subtitle class="text-right">
                <span class="mr-3">pago procesado vía</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <img class="mt-1" :src="require(`@/assets/appAsset-brand--${d.gateway}.svg`)" height="26px" />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
          <v-row v-else>
            <v-col class="pb-4 pt-2 text-center">
              <v-icon class="d-block" color="secondary" size="48">mdi-credit-card-remove</v-icon>
              <span class="d-block subtitle-2 font-weight-regular">El cliente no tiene tarjetas registradas.</span>
              <span class="d-block subtitle-2 font-weight-regular">En cada ciclo de facturación de esta suscripción se enviará un enlace de pago al cliente para que realice el pago manualmente.</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end source list -->

      <!-- products -->
      <v-card class="my-5">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Planes</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-simple-table dense class="table-hover">
            <template v-slot:default>
              <thead>
                <tr class="py-0">
                  <th class="text-left">Plan de precio</th>
                  <th style="width:320px;"></th>
                  <th class="text-right" style="width:100px;">Cantidad</th>
                  <th class="text-right" style="width:200px;">Total</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="p in instance.lines">
                  <tr :key="p.id" @click="$router.push({name: 'PlanRetrieveUpdate', params: {id: p.plan.id}})" style="cursor:pointer;">
                    <td class="py-2">
                      <v-row align="center" justify="space-between" no-gutters>
                        <v-col>
                          <span class="body-2 text--secondary font-weight-medium">{{p.plan.name}}</span>
                          <span class="d-block"><template v-if="p.plan.tiers.length">Desde </template>{{p.plan.amount | currency(p.plan.currency.id)}} {{p.plan.currency.id}} / {{p.plan.frequency.name}}</span>
                        </v-col>
                        <v-col v-if="p.plan.tiers.length || p.plan.usage_scheme === 'metered'">
                          <v-tooltip v-if="p.plan.tiers.length" right max-width="320px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" v-on="on" small color="secondary">mdi-chart-gantt</v-icon>
                            </template>
                            <v-toolbar color="transparent" flat height="42">
                              <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">Niveles de precios</v-toolbar-title>
                            </v-toolbar>
                            <v-divider />
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th style="width: 450px !important;" class="text-left">Cantidad</th>
                                    <th class="text-left">Precio</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="tier in p.plan.tiers">
                                    <tr :key="tier.to">
                                      <td class="py-2">
                                        <span class="mr-1">Desde</span>
                                        <span class="text--secondary font-weight-medium">{{tier.quantity_from}}</span>
                                        <template v-if="tier.quantity_to">
                                          <span class="mx-1">a</span>
                                          <span class="text--secondary font-weight-medium">{{tier.quantity_to}}</span>
                                        </template>
                                        <template v-else>
                                          <span class="mx-1">o</span>
                                          <span class="text--secondary font-weight-medium">más</span>
                                        </template>
                                      </td>
                                      <td>
                                        <span class="text--secondary font-weight-medium">{{tier.amount | currency(p.plan.currency.id)}}</span>
                                        <span class="mx-1">{{p.plan.currency.id}}</span>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-tooltip>
                          <v-tooltip v-if="p.plan.usage_scheme === 'metered'" right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon class="ml-2" v-on="on" small color="secondary">mdi-timelapse</v-icon>
                            </template>
                            <span>A los clientes suscritos a este plan se les facturará de acuerdo al consumo registrado para el periodo de facturación.</span>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </td>
                    <td class="caption">
                      <template v-if="p.coupon">
                        <div>
                          <span>Descuento </span>
                            <router-link class="btnLink" :to="{name: 'CouponRetrieveUpdate', params: {id: p.coupon.id}}">{{p.coupon.name}}</router-link>
                            por <span v-if="p.coupon.discount_scheme === '%'">{{p.coupon.amount | number(false)}} %</span>
                            <span v-else-if="p.coupon.discount_scheme === '$'">{{p.coupon.amount | currency(p.coupon.currency.id)}} {{p.coupon.currency.id}}</span>
                        </div>
                        <div>
                          Válido por
                          <span v-if="p.coupon.duration_scheme === 'one_time'">{{p.coupon_redemptions ? 0 : 1 }} ciclos de facturación restantes</span>
                          <span v-else-if="p.coupon.duration_scheme === 'forever'">siempre</span>
                          <span v-else-if="p.coupon.duration_scheme === 'limited'">{{p.coupon.duration_times - p.coupon_redemptions}} ciclos de facturación restantes</span>
                        </div>
                      </template>
                    </td>
                    <td class="text-right">
                      <span v-if="p.plan.usage_scheme === 'licensed'" class="body-2 text--secondary font-weight-medium">{{p.quantity}}</span>
                      <template v-else-if="p.plan.usage_scheme === 'metered'">
                        <v-btn v-if="['active', 'needs_attention'].includes(instance.status)" @click.stop="viewUsages(p.id)" color="primary" :ripple="false" text>Ver consumo</v-btn>
                        <span class="d-block" v-else>Varía con el uso</span>
                      </template>
                    </td>
                    <td class="text-right">
                      <template v-if="p.plan.usage_scheme === 'licensed'">
                        <span class="body-2 text--secondary font-weight-medium">
                          <template v-if="p.plan.tiers.length">{{computeTieredLineTotal(p) | currency(p.plan.currency.id)}}</template>
                          <template v-else>{{(p.quantity * p.plan.amount) | currency(p.plan.currency.id)}}</template>
                        </span>
                        <span class="ml-1">{{p.plan.currency.id}}</span>
                      </template>
                      <span v-else-if="p.plan.usage_scheme === 'metered'">Varía con el uso</span>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
      <!-- end products -->

      <!-- addons -->
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Complementos</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-simple-table v-if="instance.addons.length" dense>
            <template v-slot:default>
              <thead>
                <tr class="py-0">
                  <th>Complemento</th>
                  <th class="text-right">Aplicaciones restantes</th>
                  <th class="text-right" style="width:100px;">Cantidad</th>
                  <th class="text-right" style="width:150px;">Total</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="d in instance.addons">
                  <tr :key="d.addon.id" @click="$router.push({name: 'AddonRetrieveUpdate', params: {id: d.addon.id}})">
                    <td class="py-2">
                      <span class="body-2 text--secondary font-weight-medium">{{d.addon.name}}</span>
                      <div>
                        <span>{{d.addon.amount | currency(d.addon.currency.id)}} {{d.addon.currency.id}} / {{d.addon.apply_scheme === 'recurring' ? 'Recurrente' : 'Una vez'}}</span>
                      </div>
                    </td>
                    <td class="text-right">
                      <span v-if="d.addon.apply_scheme === 'recurring'">{{d.addon.duration_times - d.addon_redemptions}} ciclos de facturación</span>
                      <span v-else>{{1 - d.addon_redemptions}} ciclo de facturación</span>
                    </td>
                    <td class="text-right">
                      <span class="body-2 text--secondary font-weight-medium">{{d.quantity}}</span>
                    </td>
                    <td class="text-right">
                      <span class="body-2 text--secondary font-weight-medium">{{(d.quantity * d.addon.amount) | currency(d.addon.currency.id)}}</span> <span>{{d.addon.currency.id}}</span>
                    </td>
                  </tr>
                  <tr class="rules" v-if="d.addon.apply_scheme === 'one_time' && d.rates.length" :key="d.addon.amount">
                    <td colspan="5" class="py-4">
                      <span class="body-1 text--secondary font-weight-medium">Prorrateo del complemento</span>
                      <v-col class="pa-0">
                        <div v-for="(rate, i) in d.rates" :key="i" class="mt-4">
                          <div class="d-flex">
                            <v-row class="background text--secondary mx-2 ml-0" style="border-radius: 4px; max-width: 120px; height: 40px;" align="center" no-gutters justify="center">en el periodo</v-row>
                            <div class="mx-2" style="width:100px">
                              <v-text-field background-color="white" outlined required single-line dense :value="rate.billing_cycle" disabled hide-details />
                            </div>
                            <v-row class="background text--secondary mx-2" style="border-radius: 4px; max-width: 100px; height: 40px;" align="center" no-gutters justify="center">facturar el</v-row>
                            <div class="mx-2" style="width:100px">
                              <v-text-field suffix="%" background-color="white" outlined required single-line dense :value="rate.percentage" disabled hide-details placeholder="0" />
                            </div>
                            <v-row class="background text--secondary mx-2" style="border-radius: 4px; max-width: 180px; height: 40px;" align="center" no-gutters justify="center">con la descripción</v-row>
                            <div class="mx-2" style="width:350px">
                              <v-text-field background-color="white" outlined required single-line dense :value="rate.description" disabled hide-details />
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
          <v-row v-else>
            <v-col cols="12" class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="48">mdi-cube</v-icon>
              <span class="d-block subtitle-2 font-weight-regular">La suscripción no posee complementos</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end addons -->

      <!-- fiscal settings  -->
      <v-card class="my-5">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Avanzado</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-row>
            <v-col md="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Referencias</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="instance.references.length">
                      <div class="my-1" v-for="d in instance.references" :key="d.document"> • Documento tipo {{d.document}} del {{d.date | date}} Id {{d.serial}}. {{d.description}}</div>
                    </template>
                    <span class="font-italic text--disabled" v-else>Sin referencias</span>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title>Comentario</v-list-item-title>
                  <v-list-item-subtitle>
                    <template v-if="instance.note">{{instance.note}}</template>
                    <span class="font-italic text--disabled" v-else>Sin comentario adicional</span>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end fiscal settings -->

      <!-- metadata  -->
      <v-card class="mt-3">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Metadata</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="dialogMetadata=true" outlined color="secondary">Editar</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row>
            <v-col cols="6" v-if="Object.keys(instance.metadata).length">
              <v-list class="transparent">
                <v-list-item v-for="(v, k) in instance.metadata" :key="k">
                  <v-list-item-title>{{k}}</v-list-item-title>
                  <v-list-item-subtitle>{{v}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" v-else class="text-center py-5">
              <v-icon class="d-block" color="secondary" size="70">mdi-code-tags</v-icon>
              <span class="d-block subtitle-1">No hay metadatos</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end metadata  -->
    </v-col>

    <!-- modal delete suscripción -->
    <v-dialog v-model="dialogDestroy" width="700" persistent no-click-animation>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Cancelar suscripción</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="dialogDestroy=false" icon small retain-focus-on-click><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-8 background">
          <v-list class="v-list-form transparent">
            <v-list-item>
              <v-list-item-title>Razón de la cancelación</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="cancelReason" :items="cancelReasons" item-text="label" item-value="value" hide-details dense height="30" single-line outlined background-color="white"/>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogDestroy=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="destroy" :loading="$store.state.subscriptions.destroyLoader" color="red darken-2" dark>Cancelar suscripción</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end modal delete suscripción -->

    <!-- dialog usages -->
    <v-dialog v-model="dialogUsages" width="600" persistent no-click-animation>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Detalle de consumo para el ciclo actual</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click="dialogUsages=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0 background">
          <v-data-table v-if="usagesList.length" :headers="headers" :items="usagesList" mobile-breakpoint hide-default-footer hide-default-header disable-sort>
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.date_time`]="{item}">
              <span class="text--secondary font-weight-medium">{{item.date_time | dateTime}}</span>
            </template>
            <template v-slot:[`item.quantity`]="{item}">
              <span>{{item.quantity | number}}</span>
            </template>
          </v-data-table>
          <v-sheet class="py-8 text-center" v-else>
            <v-icon class="d-block" color="secondary" size="70">mdi-playlist-remove</v-icon>
            <span class="d-block subtitle-1">No existen registros de consumo para el ciclo actual</span>
          </v-sheet>
        </v-card-text>
        <!-- TODO add button to go to detail usages view -->
        <!-- <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn outlined>Ver historial de consumo</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
    <!-- end dialog usages -->

    <!-- dialog metadata -->
    <v-dialog v-if="instance.id" v-model="dialogMetadata" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Editar metadatos</v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-4 background">
          <v-row no-gutters v-if="editableMetadata.length" align="center">
            <v-col cols="4">
              <span class="body-2 text--secondary font-weight-medium ml-1">Clave</span>
            </v-col>
            <v-col cols="8">
              <span class="body-2 text--secondary font-weight-medium ml-1">Valor</span>
            </v-col>
          </v-row>
          <v-row no-gutters v-for="(d, i) in editableMetadata" :key="i" align="center">
            <v-col cols="4" class="py-1">
              <v-text-field v-model.trim="$v.editableMetadata.$each[i].key.$model" :error="$v.editableMetadata.$each[i].key.$error" background-color="white" outlined required single-line dense maxlength="32" hide-details />
            </v-col>
            <v-col cols="7" class="py-1">
              <v-text-field v-model.trim="$v.editableMetadata.$each[i].value.$model" :error="$v.editableMetadata.$each[i].value.$error" background-color="white" outlined required single-line dense maxlength="256" hide-details />
            </v-col>
            <v-col cols="1" class="py-1 text-right">
              <v-btn v-if="i >= 1 || editableMetadata.length > 1" @click="editableMetadata.splice(i, 1)" icon color="secondary"><v-icon small>mdi-delete</v-icon></v-btn>
            </v-col>
            <v-col cols="12" v-if="!$v.editableMetadata.$each[i].key.itsRepeated">
              <span class="d-block red--text caption ml-1 mt-n1 mb-1"><v-icon color="red" small left>mdi-alert-circle</v-icon>La clave debe ser única.</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="3">
              <v-btn @click="editableMetadata.push({ key: '', value: '' })" :disabled="editableMetadata.length >= 10" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar elemento</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogMetadata=false" outlined>Cancelar</v-btn>
          <v-btn @click="updateMetadata" :loading="loaderMetadata" :disabled="!editableMetadata.length" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog metadata -->

    <!-- dialog pdf -->
    <v-dialog v-model="modalRender" v-if="instance.id" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Próxima factura de la suscripción</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="modalRender=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row v-if="loaderRender">
            <v-col cols="12" class="py-0 ma-0">
              <v-skeleton-loader class="rounded-0" transition="fade-transition" type="table" />
            </v-col>
          </v-row>
          <v-row v-else-if="!loaderRender && !renderUrl">
            <v-col cols="12" class="py-16 text-center">
              <v-icon class="d-block" color="secondary" size="70">mdi-image-broken-variant</v-icon>
              <span class="d-block subtitle-1">PDF no disponible</span>
            </v-col>
          </v-row>
          <div id="render"></div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn :href="renderUrl" :download="`next_invoice_N${instance.id}`" color="primary" dark>Descargar PDF</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog pdf -->

    <!-- create subscription & process now -->
    <v-dialog v-model="dialogProcessSubscription" no-click-animation persistent scrollable width="680">
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium"><v-icon color="yellow darken-3" left size="20">mdi-lightning-bolt</v-icon>Procesar ahora<v-chip class="mt-n1 ml-3" color="primary" text-color="white" small>Beta</v-chip></v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="dialogProcessSubscription=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-3 background">
          <template v-if="instance.collection_scheme === 'send_invoice'">
            <v-row class="v-card-timeline" align="center" justify="center">
              <v-col class="text-center" cols="12" lg="7" md="9">
                <v-chip class="v-chip-timeline-element" outlined small text-color="primary">Resumen</v-chip>
              </v-col>
              <v-col cols="12" lg="8" md="9">
                <v-card>
                  <v-toolbar color="transparent" flat height="55">
                    <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-receipt-text-arrow-right-outline</v-icon></v-list-item-avatar>
                    <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium" v-if="currency">Factura por {{summary.total | currency(currency)}} {{currency}} <span class="text--primary body-2 font-weight-regular" v-if="currency.id !== instance.customer.currency">(facturado en {{instance.customer.currency}})</span></v-toolbar-title>
                  </v-toolbar>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="v-card-timeline" align="center" justify="center" v-if="instance.default_source || sourcesList.length">
              <v-col cols="12" lg="8" md="9">
                <v-card>
                  <v-toolbar color="transparent" flat height="55">
                    <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-cash-check</v-icon></v-list-item-avatar>
                    <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium" v-if="currency">Cargo por {{summary.total | currency(currency)}} {{currency}} <span class="text--primary body-2 font-weight-regular" v-if="currency.id !== instance.customer.currency">(cobrado en {{instance.customer.currency}})</span></v-toolbar-title>
                  </v-toolbar>
                </v-card>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12" lg="8" md="9">
                <v-card>
                  <v-toolbar color="transparent" flat height="55">
                    <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-bell-outline</v-icon></v-list-item-avatar>
                    <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">
                      <template v-if="!instance.default_source && !sourcesList.length">Envío de factura y enlace de pago al cliente</template>
                      <template v-else>Envío de factura y notificación al cliente</template>
                    </v-toolbar-title>
                  </v-toolbar>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row class="v-card-timeline" align="center" justify="center">
              <v-col class="text-center" cols="12" lg="7" md="9">
                <v-chip class="v-chip-timeline-element" outlined small text-color="primary">Resumen</v-chip>
              </v-col>
              <v-col cols="12" lg="8" md="9">
                <v-card>
                  <v-toolbar color="transparent" flat height="55">
                    <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-cash-check</v-icon></v-list-item-avatar>
                    <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium" v-if="currency">Cargo por {{summary.total | currency(currency)}} {{currency}} <span class="text--primary body-2 font-weight-regular" v-if="currency.id !== instance.customer.currency">(cobrado en {{instance.customer.currency}})</span></v-toolbar-title>
                  </v-toolbar>
                </v-card>
              </v-col>
            </v-row>
            <v-row class="v-card-timeline" align="center" justify="center">
              <v-col cols="12" lg="8" md="9">
                <v-card>
                  <v-toolbar color="transparent" flat height="55">
                    <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-receipt-text-arrow-right-outline</v-icon></v-list-item-avatar>
                    <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium" v-if="currency">Factura por {{summary.total | currency(currency)}} {{currency}} <span class="text--primary body-2 font-weight-regular" v-if="currency.id !== instance.customer.currency">(facturado en {{instance.customer.currency}})</span></v-toolbar-title>
                  </v-toolbar>
                </v-card>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="12" lg="8" md="9">
                <v-card>
                  <v-toolbar color="transparent" flat height="55">
                    <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-bell-outline</v-icon></v-list-item-avatar>
                    <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">
                      Envío de factura y notificación de cargo al cliente
                    </v-toolbar-title>
                  </v-toolbar>
                </v-card>
              </v-col>
            </v-row>
          </template>
          <v-row align="center" justify="center">
            <v-alert class="mb-3 mt-6 body-2" dense prominent color="amber lighten-4" border="left" icon="mdi-information">
              <v-row align="center">
                <v-col class="grow">
                  <span class="brown--text darken-4">Al confirmar el procesamiento de la suscripción no se puede cancelar o deshacer.</span>
                </v-col>
              </v-row>
            </v-alert>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn @click="renderDocument('subscriptions')" outlined :ripple="false">Previsualizar<v-icon right small>mdi-open-in-new</v-icon></v-btn>
          <v-spacer />
          <v-btn @click="dialogProcessSubscription=false" outlined>Cancelar</v-btn>
          <v-btn @click="processSubscription" :loading="loaderProcessSubscription" color="primary">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end create subscription & process now -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { email, required, maxLength, minLength } from 'vuelidate/lib/validators'

import moment from 'moment'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import RenderViewMixin from '@/mixins/RenderViewMixin'

import VTableHeaders from '@/components/VTable/VTableHeaders'
import SourceList from '@/components/payments/SourceList'

import { invoiceTypes } from '../../collections/documents'

export default {
  inject: ['theme'],
  components: {
    SourceList,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    },
    VTableHeaders
  },
  data: () => ({
    cancelReason: 'not_paid',
    cancelReasons: [
      { value: 'not_paid', label: 'Sin pago' },
      { value: 'no_card', label: 'Sin tarjeta de crédito o débito' },
      { value: 'fraud_review_failed', label: 'Revisión de fraude fallida' },
      { value: 'non_compliant_customer', label: 'Cliente no conforme' },
      { value: 'not_specified', label: 'No especificado' }
    ],
    currency: null,
    dialogDestroy: false,
    dialogMetadata: false,
    dialogProcessSubscription: false,
    dialogUsages: false,
    editableMetadata: [
      { key: '', value: '' }
    ],
    headers: [
      { text: 'Fecha', value: 'date_time' },
      { text: 'Consumo registrado', value: 'quantity', align: 'end' }
    ],
    isFuture: false,
    isMetered: false,
    loaderMetadata: false,
    loaderProcessSubscription: false,
    summary: {
      net: 0,
      discount: 0,
      taxes: 0,
      total: 0
    }
  }),
  mixins: [
    GenericViewMixin,
    RenderViewMixin
  ],
  computed: mapState({
    account: state => state.auth.account.id,
    instance: state => state.subscriptions.subscriptionsDetail,
    orgunitsDetail: state => state.customers.orgunitsDetail,
    sourcesList: state => state.payments.sourcesList,
    usagesCount: state => state.subscriptions.usagesCount,
    usagesList: state => state.subscriptions.usagesList
  }),
  created () {
    this.baseLoader = true

    this.$store.dispatch('subscriptions/RETRIEVE', {
      resource: 'subscriptions',
      id: this.$route.params.id
    })
    .then(() => {
      /**
       * list source depending on whether the
       * subscription has one explicitly or not
       */
      const query = {}

      if (this.instance.default_source) {
        query.id = this.instance.default_source
      } else {
        query.customer = this.instance.customer.id
        query.gateway__currencies__in = this.instance.customer.currency
        query.status = 'chargeable'
        query.usage = 'reusable'
        query.page_size = 1
      }

      this.$store.dispatch('payments/LIST', {
        resource: 'sources',
        query: query
      })
    })
    .then(() => {
      if (this.instance.orgunit) {
        this.$store.dispatch('customers/RETRIEVE', {
          resource: 'orgunits',
          id: this.instance.orgunit
        })
      }
    })
    .then(() => {
      this.editableMetadata = Object.keys(this.instance.metadata).map((k) => {
        return { key: k, value: this.instance.metadata[k] }
      })
    })
    .then(() => {
      /**
       * determine currency based on currency
       * of the first plan line
       */
      if (this.instance.lines) {
        this.currency = this.instance.lines[0].plan.currency.id
      }
    })
    .then(() => {
      /**
       * determine if this subscription is future
       * based on date_start or next_billing
       */
      const firstInvoice = this.instance.next_billing || this.instance.date_start
      this.isFuture = moment(firstInvoice).isAfter(moment())
    })
    .then(() => {
      /**
       * determine if this subscription is metered
       * based on lines plans
       */
      const meteredPlans = this.instance.lines.filter(d => d.plan.usage_scheme === 'metered')
      this.isMetered = (meteredPlans.length > 0)
    })
    .then(() => {
      /**
       * determine total amount to be charged based
       * on lines plans, addons and document type taxes
       * TODO include coupon
       * TODO include tier price to tiers mode
       * TODO include prorated addons
       */
      this.setTotal()
    })
    .catch((error) => {
      if (error.response && error.response.status === 404) {
        this.$dialog.message.info('La suscripción no existe')
        this.$router.push({ name: 'SubscriptionList' })
      }
    })
    .finally(() => {
      this.baseLoader = false
    })
  },
  methods: {
    computeTieredLineTotal (line) {
      const tier = line.plan.tiers.find((t) => (t.quantity_from <= line.quantity && t.quantity_to >= line.quantity) || (t.quantity_from <= line.quantity && t.quantity_to === 0))

      if (line.plan.tiers_mode === 'range') {
        return tier.amount
      }
      return tier.amount * line.quantity
    },
    destroy () {
      this.$dialog.warning({
        title: 'Cancelar suscripción',
        text: `
          <span class="d-block mb-4">Al cancelar esta suscripción, ya no se seguirá facturando.</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('subscriptions/DESTROY', {
                resource: 'subscriptions',
                id: this.instance.id,
                query: {
                  cancel_reason_description: this.cancelReason
                }
              })
              .then(() => {
                this.$dialog.message.info('La suscripción ha sido cancelada')
                this.$router.push({ name: 'SubscriptionList' })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    processSubscription () {
      /**
       * process subscription
       */
      this.loaderProcessSubscription = true

      this.$store.dispatch('subscriptions/RETRIEVE', {
        resource: 'subscriptions',
        detail: 'process',
        id: this.instance.id,
        loader: false
      })
      .then(() => {
        this.$dialog.message.info('La suscripción se ha procesado con éxito')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data), {
          timeout: 10000,
          actions: {
            false: {
              text: 'Cerrar',
              color: 'red darken-4'
            }
          }
        })
      })
      .finally(() => {
        this.dialogProcessSubscription = false
        this.loaderProcessSubscription = false
      })
    },
    updateMetadata () {
      this.$v.editableMetadata.$touch()

      if (this.$v.editableMetadata.$invalid) {
        return false
      }

      this.loaderMetadata = true

      this.$store.dispatch('subscriptions/UPDATE', {
        resource: 'subscriptions',
        id: this.instance.id,
        payload: {
          metadata: Object.fromEntries(this.editableMetadata.map(({ key, value }) => [key, value]))
        }
      })
      .then(() => {
        this.dialogMetadata = false
        this.$dialog.message.info('Los atributos de matadatos han sido actualizados')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.loaderMetadata = false
      })
    },
    solve () {
      this.$dialog.warning({
        title: 'Marcar como resuelto',
        text: `
          <span class="d-block mb-4">La suscripción se volverá a activar.</span>
          <span class="d-block">¿Estás seguro de continuar?</span>
        `,
        actions: [
          {
            color: 'primary',
            text: 'Marcar como resuelto',
            handle: () => {
              this.$store.dispatch('subscriptions/CREATE', {
                detail: 'resume',
                resource: 'subscriptions',
                id: this.instance.id,
                payload: {}
              })
              .then(() => {
                this.getList(false)
                this.$dialog.message.info('La suscripción ahora está activa.')
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    viewUsages (subscriptionLineId) {
      this.dialogUsages = true

      const query = {
        subscription_line: subscriptionLineId,
        date_time__lte: this.instance.next_billing,
        date_time__gt: this.instance.previous_billing
      }

      if (!this.instance.previous_billing) {
        delete query.date_time__gt
      }

      this.$store.dispatch('subscriptions/LIST', {
        resource: 'usages',
        query: query,
        loader: false
      })
    },

    /**
     * returns coupon amount based on coupon attributes
     * @param {Number} amount plan amount to be discounted
     * @param {Number} discount coupon discount amount
     * @param {String} scheme coupon scheme, one of '$', '%'
     * @param {Number} redemptions coupon redemptions count
     * @param {String} durationScheme coupon duration scheme, one of 'forever', 'limited', 'one_time'
     * @param {Number} durationTimes number of times coupon has been redeemed
     * @returns {Number} amount to be discounted
     */
    getCouponAmount (amount, discount, scheme, redemptions, durationScheme, durationTimes) {
      if ((durationScheme === 'limited' && durationTimes > redemptions) || durationScheme === 'forever' || (durationScheme === 'one_time' && redemptions === 0)) {
        if (scheme === '$') {
          return discount
        }

        return (amount * (discount / 100))
      }

      return 0
    },
    setTotal () {
      const documentType = invoiceTypes.find(d => d.id === this.instance.document)

      // aggregate lines subtotals
      this.instance.lines.forEach(line => {
        let net = line.plan.amount * line.quantity

        // if tiered plan, compute subtotal based on tier
        if (line.plan.tiers.length) {
          let tier = line.plan.tiers.find(t => t.quantity_to && t.quantity_from <= line.quantity && t.quantity_to >= line.quantity)

          // if no tier, default is last one
          if (!tier) {
            tier = line.plan.tiers[line.plan.tiers.length - 1]
          }

          net = line.plan.tiers_mode === 'unit' ? tier.amount * line.quantity : tier.amount
        }

        // add line discount
        if (line.coupon) {
          net -= this.getCouponAmount(
            net,
            line.coupon.amount,
            line.coupon.discount_scheme,
            line.coupon_redemptions,
            line.coupon.duration_scheme,
            line.coupon.duration_times
          )
        }

        this.summary.net = net
      })

      // aggregate addons subtotals
      this.instance.addons.forEach(addon => {
        const applyScheme = addon.addon.apply_scheme
        const durationTimes = addon.addon.duration_times
        const addonRedemptions = addon.addon_redemptions

        if ((applyScheme === 'recurring' && durationTimes > addonRedemptions) || (applyScheme === 'one_time' && addonRedemptions === 0)) {
          this.summary.net += addon.addon.amount * addon.quantity
        }
      })

      // aggregate discount
      if (this.instance.coupon) {
        this.summary.net -= this.getCouponAmount(
          this.summary.net,
          this.instance.coupon.amount,
          this.instance.coupon.discount_scheme,
          this.instance.coupon_redemptions,
          this.instance.coupon.duration_scheme,
          this.instance.coupon.duration_times
        )
      }

      // add taxes
      if (documentType.tax && !documentType.hasLinesTotal) {
        this.summary.taxes = this.summary.net * (documentType.tax / 100)
      }

      this.summary.total = this.summary.net + this.summary.taxes
    }
  },
  validations: {
    source: {
      recipient: {
        required,
        email
      },
      description: {
        required,
        maxLength: maxLength(256)
      }
    },
    editableMetadata: {
      $each: {
        key: {
          required,
          maxLength: maxLength(32),
          itsRepeated: function (value) {
            if (value) {
              return (this.editableMetadata.filter(d => d.key === value).length === 1)
            }
            return true
          }
        },
        value: {
          required,
          maxLength: maxLength(256)
        }
      },
      minLength: minLength(1),
      maxLength: maxLength(10)
    }
  }
}
</script>